/**
 * BYOC event names are display-only (identity is the server-generated UUID).
 * They are STORED lowercase with whitespace collapsed ("  tRiAl  expired " →
 * "trial expired") so the DB never carries casing variants, and DISPLAYED in
 * Pascal Case ("trial expired" → "Trial Expired"). The stored form doubles as
 * the duplicate key.
 */
export function toStoredByocEventName(name: string): string {
  return name.trim().split(/\s+/).join(" ").toLowerCase();
}

export function formatByocEventName(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
